import apiClient from './api';

export const getRolesByEmail = async (email: string) => {
    const response = await apiClient.get(`/role/email/${email}`);
    return response.data;
}

export const getRolesByType = async (roleType: string) => {
    const response = await apiClient.get(`/role/type/${roleType}`);
    return response.data;
}

export const createUserRoleAssignment = async (userID: number, roleID: number, moduleID: number, userGroupID?: number) => {
    const response = await apiClient.post(`/role/${roleID}/link/${userID}/${moduleID}`, null, {
        params: userGroupID ? { userGroupID } : undefined
    });
    return response.data;
}

export type GlobalKontoadminResult = {
    totalModules: number;
    changed: { moduleID: number; moduleName: string }[];
    alreadyHad: number;
}

// Kontoadmin on every ramavtal still in use (sysadmin only)
export const setGlobalKontoadmin = async (userID: number): Promise<GlobalKontoadminResult> => {
    const response = await apiClient.post(`/role/kontoadmin/global/${userID}`);
    return response.data;
}

export const removeGlobalKontoadmin = async (userID: number): Promise<GlobalKontoadminResult> => {
    const response = await apiClient.delete(`/role/kontoadmin/global/${userID}`);
    return response.data;
}

export const deleteUserRoleAssignment =async (userID: number, roleID: number, moduleID: number, userGroupID?: number) => {
    const response = await apiClient.delete(`/role/${roleID}/link/${userID}/${moduleID}`, {
        params: userGroupID ? { userGroupID } : undefined
    });
    return response.data;
}